import * as Helper from '@/modules/helper/index'
import { Post } from '@/modules/wrapper/apiWrapper'
import DeviceInfo from '@/modules/util/deviceInfo'

import {
  isPhoneGap,
  IsReportingPage,
  isInIframe
} from '@/modules/util/util'

export const RegisterApp = async(subscriptionId) => {
  if (isInIframe()) {
    return
  } else if (Helper.IsScreenCapture()) {
    return
  } else {
    let IsAlreadyRegistred = window.localStorage.getItem('IsAlreadyRegistred_' + subscriptionId)
    if (IsAlreadyRegistred === 'true') {
      return
    } else {
      let countryObj = await Helper.GetDeviceCountry(subscriptionId)
      let ReportingRegisteredApp = {
        AppGUID: Helper.GetAppGUID(subscriptionId),
        Subscription_Id: subscriptionId,
        AppType: isPhoneGap() ? 2 : 1,
        RegistrationDate: Helper.CurrentDateTime(),
        DeviceCountry: countryObj.country_code,
        DeviceRegion: countryObj.region,
        DeviceCity: countryObj.city,
        DeviceLongitude: countryObj.latitude,
        DeviceLatitude: countryObj.longitude,
        ClientIP: countryObj.ip,
        DeviceModel: isPhoneGap() ? (window.device ? window.device.model : 'None') : DeviceInfo.deviceModel,
        DevicePlatform: isPhoneGap() ? (Helper.IsValid(window.device) ? window.device.platform : DeviceInfo.osName) : 'Web App',
        DeviceVersion: isPhoneGap() ? (Helper.IsValid(window.device) ? window.device.version : DeviceInfo.osVersion) : DeviceInfo.osVersion
      }
      await Post('ReportingRegisteredApps', ReportingRegisteredApp)
        .then(response => {
          if (Helper.IsValid(response, true)) {
            // RegisterAppSessionStart()
            window.localStorage.setItem('IsAlreadyRegistred_' + subscriptionId, true)
          }
        }, response => {
          console.log('error response: ', response)
        })
    }
  }
}
export const RegisterPageViewEnter = async(payload) => {
  if (IsReportingPage()) {
    let ReportingPageViews = {
      'SubscriptionModule_Id': parseInt(payload.SubscriptionModule_Id),
      'AppGUID': Helper.GetAppGUID(payload.Subscription_Id),
      'ViewType': parseInt(payload.ViewType),
      'ContentGUID': payload.ContentGUID
    }
    await Post('ReportingPageViews', ReportingPageViews)
    .then(response => response.data)
    .catch(err => { console.log('Error In Page View api', err) })
  }
}



// WEBPACK FOOTER //
// ./src/modules/appReporting/index.js